import { withChartLayout } from 'components/common';
import ProviderOrder from 'components/features/chart/provider-chart/provider-order/ProviderOrder';

const ProviderOrderPage = withChartLayout('Provider Orders')(ProviderOrder);
export default ProviderOrderPage;
